import type { Workitem } from '@rhythmic/db/types'
import type { Transaction } from '@tanstack/vue-db'
import { z } from 'zod'
import { useRhythmicLogger } from '#imports'
import { getWorkitemsCollection } from '../getCollections'
import type { BacklogContext } from './useBacklogContext'

const logger = useRhythmicLogger('useBacklogContext:deleteWorkitem')

const DeleteWorkitemSchema = z.object({
  id: z.string().min(1, 'Workitem id is required'),
})

export function handleDeleteWorkitem(id: string, context: BacklogContext | undefined): Transaction<Workitem> {
  if (!context) throw new Error('Backlog context is not ready: missing team context')

  const parsedId = DeleteWorkitemSchema.parse({ id }).id
  const { teamId } = context

  const collection = getWorkitemsCollection(teamId)
  logger.debug('Deleting workitem from backlog context', {
    workitemId: parsedId,
    context,
  })

  const transaction = collection.delete(parsedId)
  return transaction as Transaction<Workitem>
}
